import { AllocationRule } from 'further-types/lp/allocations';
import { InvestmentTypes } from 'further-types/lp/investment';
import { RevaluationTransactionType } from 'further-types/lp/revaluation';

export const AllocationRuleLabels = {
  [AllocationRule.ByCommitmentAndClosingDate]: 'By commitment and closing date',
  [AllocationRule.Manual]: 'Manual',
  [AllocationRule.LinkedAction]: 'Linked action',
};

export const InvestmentTypeLabels = {
  [InvestmentTypes.InvestmentCreated]: 'Investment created',
  [RevaluationTransactionType.CompanyRevaluationUp]:
    'Revaluation (Unrealised equity gain)',
  [RevaluationTransactionType.CompanyRevaluationDown]:
    'Revaluation (Unrealised equity loss)',
  [InvestmentTypes.InvestmentRealisedCurrencyGain]:
    'Investment (Realised currency gain due to difference between rate at action and payment)',
  [InvestmentTypes.InvestmentRealisedCurrencyLoss]:
    'Investment (Realised currency loss due to difference between rate at action and payment)',
};
